<template>
	<div :class="classes">
		<label class="breadcrumb-label text-truncate"
			:title="text"
			v-html="text"
		></label>
		<FontAwesomeIcon
			v-if="showChevron"
			class="breadcrumb__chevron"
			:icon="[ 'fas', 'chevron-right' ]"
		/>
	</div>
</template>

<script>
export default {
	name: "Breadcrumb",
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		text: {
			type: String,
			required: true,
		},
		isActive: {
			type: Boolean,
			required: true,
		},
		showChevron: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		classes() {
			return {
				breadcrumb: true,
				"breadcrumb--active": this.isActive,
				"breadcrumb--inactive": !this.isActive,
				// TODO: disabled styles
				"breadcrumb--disabled": this.disabled,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
$breadcrumbTextColor--active: $color1-500;
$breadcrumbTextColor--inactive: $color2-500;

.breadcrumb {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 0.5rem;

	@include font-and-line-for(-1);
	font-weight: 600;
}

.breadcrumb .breadcrumb-label {
	@include anchor() {
		color: $anchorColor !important;
		font-weight: 600;
		text-decoration: none;
	}
}

.breadcrumb--active {
	color: $breadcrumbTextColor--active;
}

.breadcrumb--inactive {
	color: $breadcrumbTextColor--inactive;

	label:hover {
		text-decoration: underline;
		cursor: pointer;
	}
}

.breadcrumb__chevron {
	font-size: 0.5rem;
}
</style>
